
<template>
    <div style="display:inline-block">
        
        <v-btn v-if="isConfirming" class="delete-button error" :class="{active: isConfirming}" @click.native="raiseDeleteEvent">Delete</v-btn>
        <v-btn v-else class="delete-button grey--text" :class="{active: !isConfirming}" :disabled="disabled" @click.native="confirmDelete" icon>
            <v-icon>delete</v-icon>
        </v-btn>
    </div>
</template>

<script>

    //deleteRequirement(requirementDialog.model['.key'])

export default {
  data() {
    return {
      isConfirming: false
    }
  },
  
  props: {
      disabled: Boolean
  },

  methods: {
    confirmDelete() {
        console.log('confirming...')
        this.isConfirming = true
        let vm=this
        setTimeout(function(){
            vm.isConfirming=false
        },4000)
    },
    raiseDeleteEvent() {
      this.isConfirming = false
      this.$emit('delete')
    }
  }
}
</script>

<style scoped>


</style>




// WEBPACK FOOTER //
// DeleteButton.vue?5c5713c6